function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.9859576mm",
    height: "10.985956mm",
    viewBox: "0 0 6.9859576 10.985956",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-59.077006,-3.2202481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.122532,-6.7351921)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 63.692517,20.448418 V 10.448419 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 60.692517,15.448419 h 6 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleX);
export default __webpack_public_path__ + "static/media/single-x.7c4e998c76d054bcce2556a23ee51b01.svg";
export { ForwardRef as ReactComponent };